import autocomplete from './autocomplete.ts'
import avatar from './avatar.ts'
import badge from './badge.ts'
import dropdown from './dropdown.ts'
import button from './button.ts'
import buttonGroup from './buttonGroup.ts'
import calendar from './calendar.ts'
import checkbox from './checkbox.ts'
import inputText from './inputText.ts'
import inputMask from './inputMask.ts'
import overlayPanel from './overlayPanel.ts'
import tag from './tag.ts'
import progressSpinner from './progressSpinner.ts'
import tieredMenu from './tieredMenu.ts'
import tooltip from './tooltip.ts'
import { tabView, tabPanel } from './tabview.ts'
import skeleton from './skeleton.ts'
import { iconfield, inputicon } from './iconfield.ts'
import dialog from './dialog.ts'
import timeline from './timeline.ts'
import menu from './menu.ts'
import multiselect from './multiselect.ts'
import paginator from './paginator.ts'
import message from './message.ts'
import chip from './chip.ts'
import inputTextarea from './inputTextarea.ts'
import fileupload from './fileUpload.ts'
import progressBar from './progressbar.ts'
import inputNumber from './inputNumber.ts'
import inputSwitch from './inputSwitch.ts'

const primeStyles = {
    global: {
        css: `
        .progress-spinner-circle {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: 0;
            animation: p-progress-spinner-dash 1.5s  infinite;
            stroke-linecap: round;
        }

        @keyframes p-progress-spinner-dash{
            0% {
                stroke-dasharray: 1, 200;
                stroke-dashoffset: 0;
            }
            
            50% {
                stroke-dasharray: 89, 200;
                stroke-dashoffset: -35px;
            }
            100% {
                stroke-dasharray: 89, 200;
                stroke-dashoffset: -124px;
            }
        }

        .progressbar-value-animate::after {
            will-change: left, right;
            animation: p-progressbar-indeterminate-anim-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
        }
        .progressbar-value-animate::before {
            will-change: left, right;
            animation: p-progressbar-indeterminate-anim 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
        }
        @keyframes p-progressbar-indeterminate-anim {
            0% {
                left: -35%;
                right: 100%;
            }
            60% {
                left: 100%;
                right: -90%;
            }
            100% {
                left: 100%;
                right: -90%;
            }
        }
    `,
    },
    autocomplete,
    avatar,
    badge,
    button,
    buttonGroup,
    calendar,
    checkbox,
    chip,
    dialog,
    dropdown,
    fileupload,
    iconfield,
    inputicon,
    inputNumber,
    inputMask,
    inputSwitch,
    inputText,
    inputTextarea,
    menu,
    message,
    multiselect,
    overlayPanel,
    paginator,
    progressBar,
    tag,
    progressSpinner,
    skeleton,
    tieredMenu,
    timeline,
    tooltip,
    tabView,
    tabPanel,
}

export default primeStyles
